import React, { useState } from 'react';

import { InputBar, SendButton, TextArea } from '../styles';

interface Props {
  onSend: (message: string) => void;
  disabled: boolean;
  // Fired on first focus so a chat session can be created while the user types,
  // rather than for everyone who merely opens the drawer.
  onFocus?: () => void;
}

export function ChatInput({ onSend, disabled, onFocus }: Props) {
  const [text, setText] = useState('');

  const handleSubmit = () => {
    const trimmed = text.trim();
    if (!trimmed) {
      return;
    }
    onSend(trimmed);
    setText('');
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <InputBar>
      <TextArea
        disabled={disabled}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setText(e.target.value)}
        onFocus={onFocus}
        onKeyDown={handleKeyDown}
        placeholder="Your message..."
        rows={1}
        value={text}
      />

      <SendButton disabled={disabled || !text.trim()} onClick={handleSubmit} type="button">
        Send
      </SendButton>
    </InputBar>
  );
}
